import React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { connect } from "react-redux";
import { agentLandingQuote } from "../state/appActions";
import { PATHS, NO_QUOTE_LABEL } from "../AppConstants";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import Utilities from "../classes/Utilities";
import Analytics from "../classes/Analytics";
import { IAppState } from "../state/interfaces";
import { IVehicle } from "../classes/Domain";

interface IState extends IQuoteStepState {
    quoteUid: string
}

export interface IProps extends RouteComponentProps {
    quoteUid: string,
    vehicles: Array<IVehicle>,
    updateAppState: (quoteUid: string) => Promise<any>;
}

class AgentLandingQuote extends React.Component<IProps, IState> {
    componentDidMount() {
        this.setState({ updatingStore: true }, () => {

            this.props.updateAppState(this.props.quoteUid)
                .then((result) => {
                    Analytics.onPageRouteChanged(
                        result.quoteId?.toString() ?? NO_QUOTE_LABEL,
                        "",
                        this.props.location.pathname
                    );

                    if (this.props.vehicles.length === 0) {
                        this.props.history.replace(PATHS.START);
                    } else {
                        this.props.vehicles.map((veh, i) => {
                            this.props.history.push(Utilities.formatUrl(PATHS.VEHICLE_YMM, i === 0 ? "" : i.toString()));
                            this.props.history.push(Utilities.formatUrl(PATHS.HOW_YOU_DRIVE, i === 0 ? "" : i.toString()));
                        });
                    }
                },
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    }
                );
        });
    }

    render() {
        return null;
    }
}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {
    var quoteUid = !ownProps.match.params["quoteUid"]
        ? null
        : ownProps.match.params["quoteUid"];

    return {
        quoteUid: quoteUid,
        vehicles: state.vehicles
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        updateAppState: (quoteUid) => dispatch(agentLandingQuote(quoteUid))
    };
};

export default connect(mapProps, mapDispatch)(AgentLandingQuote);